module.exports = __webpack_public_path__ + "static/img/14000549.c1e3684a.png";